export default "__VITE_ASSET__448a0570__"